import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { SingleSelect } from "~/components/Select/SingleSelect";
const logicSelectOptions = [
    {
        value: "and",
        label: "Contains"
    },
    {
        value: "or",
        label: "Contains one of..."
    },
    {
        value: "not",
        label: "Does not contain"
    }
];
const allLogicOptions = [
    "and",
    "or",
    "not"
];
export const FilterLogicSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedLogic, onLogicChange, logicOptions = allLogicOptions } = param;
    const onSelectionChange = useCallback((param)=>{
        let { chips } = param;
        onLogicChange(chips[chips.length - 1].value);
    }, [
        onLogicChange
    ]);
    const availableOptions = useMemo(()=>logicSelectOptions.filter((option)=>logicOptions.includes(option.value)), [
        logicOptions
    ]);
    return /*#__PURE__*/ _jsx(SingleSelect, {
        options: availableOptions,
        selectedOption: logicSelectOptions.find((option)=>option.value === selectedLogic),
        onSelectionChange: onSelectionChange,
        placeholder: "",
        size: "large",
        className: "mb-4"
    });
});
FilterLogicSelect.displayName = "FilterLogicSelect";
